import store from '@/store/index.js'

export const BtnPowerConsts = {
  BATCHSYNCTOERP: 150001001,//批量同步快麦通资料到ERP资料
  DECORATESHOP: 24000001,//装饰小店
}

// 供销商按钮权限
export const S_BtnPowerConsts = {
  PROD_CENTER_PUBLIC_GOODS: 150001002, // 商品中心 - 铺货
  PROD_CENTER_EDIT: 150001003, // 商品中心 - 编辑
  PROD_CENTER_ADD: 150001004, // 商品中心 - 新增
  PROD_CENTER_DELETE: 150001005, // 商品中心 - 删除商品
  PROD_CENTER_BATCH_DELISTING: 150001006, // 商品中心 - 批量下架
  PROD_CENTER_BATCH_UPDATE_GOODS: 150001001, // 商品中心 - 批量更新资料
  PROD_CENTER_BATCH_MODIFY_OPERATION: 'SupplierDataManualEdit', // 我的小店 - 供销商数据手动编辑	
}


// 分销商按钮权限
export const D_BtnPowerConsts = {
  PROD_CENTER_PUBLIC_GOODS: 2100011000, // 商品中心 - 铺货
  PROD_CENTER_EDIT: 2100011001, // 商品中心 - 编辑
  PROD_CENTER_ADD: 2100011002, // 商品中心 - 新增
  PROD_CENTER_DELETE: 2100011003, // 商品中心 - 删除商品
  PROD_CENTER_BATCH_DELISTING: 2100011004, // 商品中心 - 批量下架
  PROD_CENTER_TO_DISTRIBUTION_GOODS: 2100011005, // 商品中心 - 转为分销商品
  PROD_CENTER_TO_SELF_GOODS: 2100011006, // 商品中心 - 转为自发商品
  PROD_CENTER_BATCH_UPDATE_GOODS: 2100011007, // 商品中心 - 批量更新资料
  PROD_CENTER_STOCK_SYNC: 2100011008, // 商品中心 - 改库存同步
}



export const CheckPower = (powerId) =>{
  const {supplyPrivilegeSetting='', isDefaultStaff} = store.getters.userInfo
      if(isDefaultStaff) {
        return true;
      } else {
        const powerList = supplyPrivilegeSetting.split(',');
        return powerList.includes(powerId+'');
      }
}
export const CheckFeatureWhitelistPower = (powerId) => {
    const { featureCodes } = store.getters.userInfo
    return featureCodes.includes(powerId)
  }


